import React from 'react'
import { Body, Button, ButtonIcon, Heading, ThemeProvider } from '@dasa-health/alma-react'
import { ErrorStateView } from 'redesign/typings/errorStateView'
import { BackButtonWrapper, Wrapper } from './styles'
import { navTheme } from 'theme'
import { userDeviceDetect } from 'utils'
import { ArrowLeft } from '@dasa-health/alma-icons'
import { useHistory } from 'react-router'
import AttentionIllustration from 'redesign/assets/svg/attention.svg'

type ErrorViewProps = {
    content?: ErrorStateView
}

export const ErrorView: React.FC<ErrorViewProps> = ({ content }) => {
    const {
        buttonRedirectTo = '/entrar',
        title = 'Erro ao carregar a página',
        buttonTitle = 'Voltar ao início',
        // eslint-disable-next-line max-len
        description = 'Encontrei uma instabilidade para carregar minha página, mas já notifiquei o time técnico para resolver isso. Que tal tentar novamente em breve?',
        illustrationImage = AttentionIllustration,
    } = content || {}

    const history = useHistory()
    const { isPortable } = userDeviceDetect()

    const handleButton = () => {
        history.replace(buttonRedirectTo)
    }

    return (
        <ThemeProvider theme={navTheme}>
            <Wrapper>
                {/* <img alt="Ilustração" src={content.illustrationImage} />
                <h1>{content.illustrationImage}</h1> */}
                {isPortable && (
                    <BackButtonWrapper>
                        <ButtonIcon leadingIcon={<ArrowLeft />} onClick={handleButton} />
                    </BackButtonWrapper>
                )}
                {illustrationImage && <img alt="Ilustração" src={illustrationImage} />}
                <Heading as="h1" className="heading" size={isPortable ? 'lg' : 'xl'}>
                    {title}
                </Heading>
                {description && (
                    <Body className="body" maxWidth="648" textAlign="center">
                        {description}
                    </Body>
                )}
                <Button
                    fullWidth={isPortable}
                    onClick={handleButton}
                    sx={{ marginTop: isPortable ? 'auto' : '0' }}
                    type="button"
                    variant="primary"
                >
                    {buttonTitle}
                </Button>
            </Wrapper>
        </ThemeProvider>
    )
}
